module.exports = __webpack_public_path__ + "img/tab2.ee5074b4.png";